import { getStorageUrl } from "../../config/config";

// 🆕 Estilos de los botones de icono (inline para no depender del CSS global)
const iconoBase = {
  width: '34px',
  height: '34px',
  border: 'none',
  borderRadius: '8px',
  cursor: 'pointer',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: '16px',
  textDecoration: 'none',
  padding: 0,
};

const iconoColores = {
  pdf: { background: '#48bb78' },
  json: { background: '#ed8936' },
  anular: { background: '#e53e3e' },
  ver: { background: '#4299e1' },
  reimprimir: { background: '#e2e8f0' },
  deshabilitado: { background: '#edf2f7', opacity: 0.4, cursor: 'not-allowed' },
};

export default function InvoiceRow({ 
  invoice, 
  onAnular, 
  onVerInvalidacion,
  onDescargarInvalidacion, // Mantener prop pero no usar
  isDownloadingInvalidacion, // Mantener prop pero no usar
  onReprint
}) {
  // Función para determinar el badge de estado
  const getEstadoBadge = () => {
    const estado = invoice.estado_dte;
    
    switch(estado) {
      case 'VALIDADO':
        return <span className="badge badge-success">✓ Validado</span>;
      case 'ANULADO':
        return <span className="badge badge-danger">✕ Anulado</span>;
      case 'RECHAZADO':
        return <span className="badge badge-danger">✗ Rechazado</span>;
      case 'PENDIENTE':
        return <span className="badge badge-warning">⏳ Pendiente</span>;
      default:
        return <span className="badge badge-secondary">{estado}</span>;
    }
  };

  // Función para determinar el tipo de DTE
  const getTipoDteBadge = () => {
    const tipo = invoice.tipo_documento;
    
    switch(tipo) {
      case '01':
        return <span className="badge badge-info" style={{ fontSize: '11px' }}>CF</span>;
      case '03':
        return <span className="badge badge-primary" style={{ fontSize: '11px' }}>CCF</span>;
      case '05':
        return <span className="badge badge-warning" style={{ fontSize: '11px' }}>NC</span>;
      default:
        return <span className="badge badge-secondary" style={{ fontSize: '11px' }}>{tipo}</span>;
    }
  };

  // 🆕 Hora de emisión (sale de fecha_emision, que trae fecha y hora)
  const getHora = () => {
    if (!invoice.fecha_emision) return "—";
    const fecha = new Date(String(invoice.fecha_emision).replace(" ", "T"));
    if (isNaN(fecha)) return "—";
    return fecha.toLocaleTimeString("es-SV", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true
    });
  };

  // 🆕 Cajero que facturó (usuario guardado en la factura)
    // 🆕 Cajero que facturó (usuario guardado en la factura)
  const getCajero = () => {
    const user = invoice.user;
    if (user) return user.name ?? user.nombre ?? "—";

    // Sin usuario: si es posterior al cambio, la hizo la cuenta principal
    const esNueva = String(invoice.fecha_emision ?? "") >= "2026-09-26";
    return esNueva ? "Administrador" : "—";
  };

  return (
    <tr style={{ opacity: invoice.estado_dte === 'ANULADO' ? 0.6 : 1 }}>
      <td>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
          <span className="badge badge-primary">
            {invoice.codigo_generacion ?? "N/A"}
          </span>
          {getTipoDteBadge()}
        </div>
      </td>
      
      <td>{invoice.sale?.client?.nombre ?? "Cliente no disponible"}</td>
      
      <td>
        {invoice.fecha_emision
          ? new Date(invoice.fecha_emision).toLocaleDateString("es-ES", {
              day: "2-digit",
              month: "2-digit",
              year: "numeric"
            })
          : "—"}
      </td>

      {/* 🆕 Hora */}
      <td>{getHora()}</td>

      {/* 🆕 Facturada por */}
      <td>{getCajero()}</td>

      {/* Estado */}
      <td>
        {getEstadoBadge()}
      </td>

      {/* 🆕 Acciones: PDF, JSON, Anular/Ver y Reimprimir como iconos */}
      <td>
        <div style={{ display: 'flex', gap: '6px', justifyContent: 'center', alignItems: 'center' }}>

          {/* PDF */}
          {invoice.pdf_path ? (
            <a
              href={getStorageUrl(invoice.pdf_path, "pdf")}
              target="_blank"
              rel="noopener noreferrer"
              style={{ ...iconoBase, ...iconoColores.pdf }}
              title="Ver PDF"
            >
              📄
            </a>
          ) : (
            <span style={{ ...iconoBase, ...iconoColores.deshabilitado }} title="PDF no disponible">
              📄
            </span>
          )}

          {/* JSON - SIN BOTÓN DE INVALIDACIÓN */}
          {invoice.json_path ? (
            <a
              href={getStorageUrl(invoice.json_path, "json")}
              target="_blank"
              rel="noopener noreferrer"
              style={{ ...iconoBase, ...iconoColores.json }}
              title="Ver JSON"
            >
              📋
            </a>
          ) : (
            <span style={{ ...iconoBase, ...iconoColores.deshabilitado }} title="JSON no disponible">
              📋
            </span>
          )}

          {/* Anular / Ver Invalidación */}
          {invoice.estado_dte === 'VALIDADO' ? (
            <button
              style={{ ...iconoBase, ...iconoColores.anular }}
              onClick={() => onAnular(invoice)}
              title="Anular factura"
            >
              🗑️
            </button>
          ) : invoice.estado_dte === 'ANULADO' ? (
            <button
              style={{ ...iconoBase, ...iconoColores.ver }}
              onClick={() => onVerInvalidacion(invoice)}
              title="Ver detalles de anulación"
            >
              🔍
            </button>
          ) : (
            <span style={{ ...iconoBase, ...iconoColores.deshabilitado }} title="Sin acción disponible">
              🗑️
            </span>
          )}

          {/* Reimprimir */}
          <button
            style={{ ...iconoBase, ...iconoColores.reimprimir }}
            onClick={() => onReprint(invoice)}
            title="Reimprimir ticket"
          >
            🖨️
          </button>
        </div>
      </td>
    </tr>
  );
}